import { useState } from "react";

export const useOpenChatDrawer = () => {
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);

  const handleOpenChatDrawer = () => {
    setIsChatOpen(true);
  };

  const handleCloseChatDrawer = () => {
    setIsChatOpen(false);
  };

  return {
    isChatOpen,
    handleOpenChatDrawer,
    handleCloseChatDrawer,
  };
};
